"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var styles_1 = require("@mui/material/styles");
var q_play_components_1 = require("@nordicscreen/q-play-components");
var react_1 = __importStar(require("react"));
var react_admin_1 = require("react-admin");
var Players_module_css_1 = __importDefault(require("./Players.module.css"));
var react_i18next_1 = require("react-i18next");
var RAStyles_1 = require("../common/ReactAdmin/RAStyles");
var Pagination_1 = __importDefault(require("../common/ReactAdmin/Pagination"));
var IsOnlineField_1 = __importDefault(require("./IsOnlineField"));
var types_1 = require("@/Types/types");
var AccessControl_1 = __importDefault(require("../common/AccessControl"));
var userPermissions_1 = require("@/Hooks/userPermissions");
var ApiManager_1 = __importDefault(require("@/functions/ApiManager"));
var CustomDatagrid_1 = require("./CustomDatagrid");
var SortArrayContext_1 = require("./SortArrayContext");
var PlayerScreenshotField = function () {
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var record = (0, react_admin_1.useRecordContext)();
    var _a = (0, react_1.useState)(), screenshotElement = _a[0], setScreenshotElement = _a[1];
    var _b = (0, react_1.useState)(), screenshotDate = _b[0], setScreenshotDate = _b[1];
    var getScreenshot = function () {
        ApiManager_1.default.getScreenshot(record.player_token).then(function (resp) {
            setScreenshotDate(resp.createdAt);
            setScreenshotElement(react_1.default.createElement("img", { style: {
                    maxWidth: "300px",
                    maxHeight: "100px"
                }, src: resp.path + "?t=" + resp.createdAt }));
        }).catch(function () {
            setScreenshotElement(react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faImageLandscape, color: "var(--lightgray-color)", size: "6x" }));
            setScreenshotDate(t("Never"));
        });
    };
    (0, react_1.useEffect)(function () {
        getScreenshot();
    }, []);
    return (react_1.default.createElement("div", { style: { maxHeight: "150px", maxWidth: "300px", color: "var(--info-color)" } },
        screenshotElement,
        react_1.default.createElement("br", null),
        screenshotDate));
};
var PlayerBlackscreen = function () {
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var record = (0, react_admin_1.useRecordContext)();
    if (!record.on_off_schedule_active) {
        return (react_1.default.createElement("div", { style: { color: "var(--info-color)" } }, t("No active schedule")));
    }
    var schedule = JSON.parse(record.on_off_schedule);
    var now = new Date();
    var currentDaySchedule = schedule.at(now.getDay() - 1);
    return (react_1.default.createElement("div", { style: { color: "var(--info-color)" } },
        currentDaySchedule.turnOnTime,
        " - ",
        currentDaySchedule.turnOffTime));
};
var CheckBoxAction = function (_a) {
    var onCheckBoxTick = _a.onCheckBoxTick;
    var selectedIds = (0, react_admin_1.useListContext)().selectedIds;
    (0, react_1.useEffect)(function () {
        onCheckBoxTick(selectedIds);
    }, [selectedIds]);
    return react_1.default.createElement(react_1.default.Fragment, null);
};
var generateSortFields = function (sortArray) {
    if (sortArray.length == 2) {
        return [
            { field: sortArray[0], order: sortArray[1] }
        ];
    }
    else if (sortArray.length == 4) {
        return [
            { field: sortArray[0], order: sortArray[1] },
            { field: sortArray[2], order: sortArray[3] }
        ];
    }
    else {
        return [];
    }
};
var PlayersOverview = function (props) {
    var permissions = props.permissions, addPresentationModalShown = props.addPresentationModalShown, bulkActionPlayerIds = props.bulkActionPlayerIds, setBulkActionPlayerIds = props.setBulkActionPlayerIds, setConfirmationModalOpened = props.setConfirmationModalOpened, setPlayerDetailsModalShown = props.setPlayerDetailsModalShown, setSelectedPlayer = props.setSelectedPlayer;
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var filters = [react_1.default.createElement(react_admin_1.SearchInput, { source: "name", alwaysOn: true, key: "queryFilter", placeholder: t("Search") })];
    var _a = (0, react_1.useState)(false), checkBoxIsActive = _a[0], setCheckBoxIsActive = _a[1];
    var directPlayerPermissionResourceType = types_1.ResourceType.PLAYER.toLowerCase() + "s";
    var hasPermission = (0, userPermissions_1.usePermissions)().hasPermission;
    var sortArray = (0, SortArrayContext_1.useSortArray)().sortArray;
    var _b = (0, react_1.useState)(generateSortFields(sortArray)), sortFields = _b[0], setSortFields = _b[1];
    (0, react_1.useEffect)(function () {
        if (addPresentationModalShown) {
            setPlayerDetailsModalShown(false);
        }
    }, [addPresentationModalShown]);
    var onCheckBoxTickHandler = function (selectedIds) {
        if (selectedIds.length > 0) {
            setCheckBoxIsActive(true);
            setBulkActionPlayerIds(selectedIds);
        }
        else {
            setCheckBoxIsActive(false);
            setBulkActionPlayerIds([]);
        }
    };
    var actionPermissions = (0, react_1.useMemo)(function () {
        return {
            canRead: bulkActionPlayerIds.every(function (id) { return hasPermission(permissions.read, id, directPlayerPermissionResourceType); }),
            canWrite: bulkActionPlayerIds.every(function (id) { return hasPermission(permissions.write, id, directPlayerPermissionResourceType); }),
            canManage: bulkActionPlayerIds.every(function (id) { return hasPermission(permissions.manage, id, directPlayerPermissionResourceType); }),
            canManageGroup: bulkActionPlayerIds.every(function (id) {
                return hasPermission("resource-group-manager", id, directPlayerPermissionResourceType) ||
                    hasPermission("global-players-manager", undefined, "global");
            }),
        };
    }, [bulkActionPlayerIds, directPlayerPermissionResourceType, hasPermission]);
    return (react_1.default.createElement(react_admin_1.ListBase, { queryOptions: {
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
            refetchOnMount: true,
            refetchInterval: 1000 * 60
        } },
        react_1.default.createElement("div", { className: Players_module_css_1.default.searchbar_container },
            react_1.default.createElement(styles_1.ThemeProvider, { theme: RAStyles_1.RaSearchInputTheme },
                react_1.default.createElement(react_admin_1.FilterForm, { filters: filters })),
            react_1.default.createElement(q_play_components_1.Button, { variant: "empty", size: "small", className: "".concat(Players_module_css_1.default.filter_button, " d-flex align-items-center justify-content-center") },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faBarsFilter, style: { fontSize: "28px" }, color: "var(--info-color)" }))),
        react_1.default.createElement("div", { className: Players_module_css_1.default.list_view_quick_actions_container },
            react_1.default.createElement(AccessControl_1.default, { optionalPermissions: permissions.manage, resourceType: directPlayerPermissionResourceType },
                react_1.default.createElement(q_play_components_1.Button, { text: t("Restart"), variant: "empty", size: "small", style: { background: "var(--bs-body-bg)" }, className: Players_module_css_1.default.list_view_quick_actions, isDisabled: !checkBoxIsActive || !actionPermissions.canWrite, onClick: function () { return props.onBulkActionHandler("rebootDevice"); } }),
                react_1.default.createElement(q_play_components_1.Button, { text: t("Update"), variant: "empty", size: "small", style: { background: "var(--bs-body-bg)" }, className: Players_module_css_1.default.list_view_quick_actions, isDisabled: !checkBoxIsActive || !actionPermissions.canManage, onClick: function () { return props.onBulkActionHandler("updateSoftware"); } })),
            react_1.default.createElement(AccessControl_1.default, { optionalPermissions: permissions.read, resourceType: directPlayerPermissionResourceType },
                react_1.default.createElement(q_play_components_1.Button, { text: t("Screen Capture"), variant: "empty", size: "small", style: { background: "var(--bs-body-bg)", whiteSpace: "nowrap" }, className: Players_module_css_1.default.list_view_quick_actions, isDisabled: !checkBoxIsActive || !actionPermissions.canRead, onClick: function () { return props.onBulkActionHandler("screenCapture"); } })),
            react_1.default.createElement(AccessControl_1.default, { optionalPermissions: permissions.write, resourceType: directPlayerPermissionResourceType },
                react_1.default.createElement(q_play_components_1.Button, { text: t("Update Presentation"), variant: "empty", size: "small", style: { background: "var(--bs-body-bg)", whiteSpace: "nowrap" }, className: Players_module_css_1.default.list_view_quick_actions, isDisabled: !checkBoxIsActive || !actionPermissions.canWrite, onClick: function () { return props.onBulkActionHandler("reloadContent"); } })),
            react_1.default.createElement(AccessControl_1.default, { optionalPermissions: permissions.manage, resourceType: directPlayerPermissionResourceType },
                react_1.default.createElement(q_play_components_1.Button, { text: t("Delete"), variant: "empty", size: "small", style: { background: "var(--bs-body-bg)" }, className: Players_module_css_1.default.list_view_quick_actions, isDisabled: !checkBoxIsActive || !actionPermissions.canManageGroup, onClick: function () {
                        if (bulkActionPlayerIds.length == 1) {
                            setSelectedPlayer({ id: bulkActionPlayerIds[0] });
                            setConfirmationModalOpened(true);
                        }
                        else {
                            props.toggleDeleteMultipleConfirmationModal();
                        }
                    } })),
            react_1.default.createElement(AccessControl_1.default, { optionalPermissions: permissions.manage, resourceType: directPlayerPermissionResourceType },
                react_1.default.createElement(q_play_components_1.Button, { text: t("Add event"), variant: "empty", size: "small", style: { background: "var(--bs-body-bg)" }, className: Players_module_css_1.default.list_view_quick_actions, isDisabled: !checkBoxIsActive || !actionPermissions.canManageGroup, onClick: function () {
                        setSelectedPlayer(null);
                        props.toggleAddEvents();
                    } }))),
        react_1.default.createElement(styles_1.ThemeProvider, { theme: RAStyles_1.RaDatagridTheme },
            react_1.default.createElement(CustomDatagrid_1.CustomDatagrid, { hover: false, rowClick: function (id, basePath, record) {
                    setSelectedPlayer(record);
                    setPlayerDetailsModalShown(true);
                    return false;
                }, sx: RAStyles_1.RaDataGridSx, bulkActionButtons: react_1.default.createElement(CheckBoxAction, { onCheckBoxTick: onCheckBoxTickHandler }), sortfields: sortFields, setsortfields: setSortFields },
                react_1.default.createElement(react_admin_1.TextField, { source: "id", label: t("ID"), sx: __assign(__assign({}, RAStyles_1.RaTextFieldSx), { fontFamily: "Geomanist" }) }),
                react_1.default.createElement(react_admin_1.TextField, { source: "name", label: t("Name"), sx: RAStyles_1.RaTextFieldSx }),
                react_1.default.createElement(react_admin_1.WrapperField, { label: t("Screenshot"), sortable: false },
                    react_1.default.createElement(PlayerScreenshotField, null)),
                react_1.default.createElement(react_admin_1.TextField, { source: "player_group.name", sortBy: "player_groups.name", label: t("Group"), sx: RAStyles_1.RaTextFieldSx }),
                react_1.default.createElement(react_admin_1.FunctionField, { label: t("Presentations"), sortable: false, render: function (record) { return "".concat(record.player_presentations.length); } }),
                react_1.default.createElement(react_admin_1.TextField, { label: t("Type"), sortBy: "device_types.name", source: "device_type.name", sx: RAStyles_1.RaTextFieldSx }),
                react_1.default.createElement(react_admin_1.TextField, { source: "content_host_id", label: t("Content host"), sx: __assign(__assign({}, RAStyles_1.RaTextFieldSx), { fontFamily: "Geomanist" }) }),
                react_1.default.createElement(react_admin_1.WrapperField, { label: t("Black screen schedule"), sortable: false },
                    react_1.default.createElement(PlayerBlackscreen, null)),
                react_1.default.createElement(react_admin_1.DateField, { label: t("Last online"), source: "player_statuses.updated_at", showTime: true, options: { hour12: false } }),
                react_1.default.createElement(react_admin_1.FunctionField, { label: t("Status"), render: function () { return react_1.default.createElement(IsOnlineField_1.default, { view: "list" }); }, sortBy: "player_statuses.updated_at" }))),
        react_1.default.createElement(Pagination_1.default, null)));
};
exports.default = PlayersOverview;
